import { GLOBAL_LOCALE_CODES, GLOBAL_UI_LOCALES } from "./localeRegistry";
import { EAGER_NAMESPACES } from "./namespaces";

const localeJsonContext = require.context(
  "./locales",
  true,
  /^\.\/[^/]+\/[^/]+\.json$/
);

/** Leitura síncrona (webpack) de um namespace; null se o arquivo não existir. */
export function getLocaleNamespaceJson(lang, namespace) {
  const key = `./${lang}/${namespace}.json`;
  if (!localeJsonContext.keys().includes(key)) return null;
  return localeJsonContext(key);
}

export function collectLocaleBucketsFromDisk() {
  const buckets = {};
  localeJsonContext.keys().forEach((key) => {
    const m = key.match(/^\.\/([^/]+)\/([^/]+)\.json$/);
    if (!m) return;
    const [, lang, ns] = m;
    if (!buckets[lang]) buckets[lang] = {};
    buckets[lang][ns] = localeJsonContext(key);
  });
  return buckets;
}

function isPackComplete(pack) {
  return pack && EAGER_NAMESPACES.every((ns) => pack[ns] != null);
}

/**
 * Monta o objeto `resources` do i18next só para idiomas listados em GLOBAL_LOCALE_CODES e com pacote completo.
 */
export function buildBuiltinI18nResources() {
  const buckets = collectLocaleBucketsFromDisk();
  const resources = {};

  for (const code of GLOBAL_LOCALE_CODES) {
    const pack = buckets[code];
    if (!pack) {
      console.warn(
        `[i18n] "${code}" está em localeRegistry mas falta a pasta locales/${code}/ (ou está vazia).`
      );
      continue;
    }
    if (!isPackComplete(pack)) {
      const missing = EAGER_NAMESPACES.filter((ns) => pack[ns] == null);
      console.warn(
        `[i18n] Idioma "${code}" ignorado até existirem os JSON: ${missing.join(", ")}`
      );
      continue;
    }
    resources[code] = {};
    for (const ns of EAGER_NAMESPACES) {
      resources[code][ns] = pack[ns];
    }
  }

  if (!resources["pt-BR"]) {
    console.error("[i18n] pt-BR é obrigatório e não foi carregado. Verifique localeRegistry e locales/pt-BR/.");
  }

  return resources;
}

/** Entradas do catálogo que já têm pacote completo no disco (para selects de login/perfil). */
export function getGlobalLocalesForUiSelect() {
  const buckets = collectLocaleBucketsFromDisk();
  return GLOBAL_UI_LOCALES.filter((entry) => isPackComplete(buckets[entry.code]));
}
